import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import BIRService from "api/BIRService";
import { useEffect, useMemo, useState } from "react";
import { IGUSCompany } from "dto/IGUSCompany";
import { isValidNip } from "utils/IsValidNip";
import { useDebounce } from "use-debounce";
import { useTranslation } from "react-i18next";

const SearchByNip: FC<Props> = ({
  isError = "",
  defaultValue,
  onDataChange,
  onChange,
  onBlur,
}) => {
  const { t } = useTranslation();
  const [nip, setNip] = useState(defaultValue ?? "");
  const [debouncedNip] = useDebounce(nip, 300);
  const { data, refetch } = BIRService.useGetCompanyFromNIP(
    debouncedNip.replaceAll(" ", "")
  );

  const company: IGUSCompany = useMemo(
    () => (data?.data as IGUSCompany) ?? [],
    [data]
  );

  useEffect(() => {
    if (!company?.Name?.length) return;
    onDataChange(company);
  }, [company]);

  const handleSearch = () => {
    if (isValidNip(nip)) {
      refetch();
    }
  };

  return (
    <div className={styles.wrapper}>
      <Input
        focus
        isNip
        onBlur={onBlur}
        isError={isError}
        onChange={(t) => {
          setNip(t);
          onChange(t);
        }}
        value={nip}
        label={t("forms.nip")}
        placeholder="NIP"
        onRightClick={handleSearch}
        onRightText={t("common.search")}
      />
    </div>
  );
};

export default SearchByNip;
